const translations = {
  // Nav
  nav_home: "Home",
  nav_about: "Chi siamo",
  nav_plans: "Piani pensionistici",
  nav_calculator: "Calcolatore",
  nav_benefits: "Vantaggi",
  nav_contact: "Contatti",
  nav_open_account: "Apri conto",

  // Hero
  hero_badge: "Fondo pensione statale norvegese",
  hero_title_1: "Il tuo futuro",
  hero_title_2: "finanziario",
  hero_title_3: "inizia oggi",
  hero_desc: "Contratti di investimento con rendimenti garantiti dal 3% al 198%. Pagamenti pensionistici stabili e reddito da dividendi ogni mese.",
  hero_cta_calc: "Calcola pensione",
  hero_cta_learn: "Scopri di più",
  hero_stat_assets: "Attività gestite",
  hero_stat_companies: "Aziende in portafoglio",
  hero_stat_countries: "Paesi di investimento",
  hero_stat_years: "Anni di esperienza",

  // About
  about_badge: "Sul Fondo",
  about_title_1: "Il più grande fondo pensione sovrano",
  about_title_2: "del mondo",
  about_desc1: "Government Pension Fund Global (GPFG) è il fondo pensione statale norvegese, fondato nel 1990. Il fondo gestisce attività per oltre €1,4 trilioni, rendendolo il più grande fondo sovrano del mondo.",
  about_desc2: "Il fondo investe in azioni di oltre 9.000 aziende in 70 paesi, garantendo la massima diversificazione e protezione del capitale. Ogni contratto di investimento è garantito dallo stato norvegese.",
  about_feat1: "Rating Moody's AAA",
  about_feat2: "Ministero delle Finanze norvegese",
  about_feat3: "Investimenti in 70 paesi",
  about_feat4: "Garanzia statale 100%",
  about_cta: "Scegli un piano",
  about_years: "anni di lavoro affidabile",

  // Plans
  plans_badge: "Contratti di investimento",
  plans_title: "Scegli il tuo piano pensionistico",
  plans_desc: "Tre livelli di contratti di investimento con rendimenti garantiti. Maggiore è l'importo — maggiore è il reddito da dividendi.",
  plans_badge1: "Livello base",
  plans_badge2: "Scelta popolare",
  plans_badge3: "Massimo beneficio",
  plans_tier1: "Starter",
  plans_tier2: "Ottimale",
  plans_tier3: "Premium",
  plans_contract: "contratto di investimento",
  plans_per_month: "al mese",
  plans_monthly: "Mensile:",
  plans_sign: "Firma contratto",
  plans_feat1_1: "Rendimento mensile 3–5%",
  plans_feat1_2: "Pagamenti mensili",
  plans_feat1_3: "Garanzia statale",
  plans_feat1_4: "Conto online investitore",
  plans_feat1_5: "Consulenza gratuita",
  plans_feat2_1: "Fino al 103% mensile",
  plans_feat2_2: "Dividendi potenziati",
  plans_feat2_3: "Servizio prioritario",
  plans_feat2_4: "Manager personale",
  plans_feat2_5: "Reinvestimento dei profitti",
  plans_feat3_1: "Rendimento mensile 157–198%",
  plans_feat3_2: "Servizio VIP",
  plans_feat3_3: "Manager personale",
  plans_feat3_4: "Bonus trimestrali",
  plans_feat3_5: "Investimenti esclusivi",
  plans_disclaimer: "* I rendimenti si basano sui dati storici del fondo. Gli investimenti sono protetti dalla garanzia statale norvegese.",

  // Calculator
  calc_badge: "Calcolatore di rendimento",
  calc_title: "Calcola la tua futura pensione",
  calc_promo: "Da <1>€3.000</1> — già <2>103%</2> al mese!",
  calc_promo_pre: "Da",
  calc_promo_mid: "— già",
  calc_promo_post: "al mese!",
  calc_amount_label: "Importo del contratto",
  calc_tier1_label: "3–5%",
  calc_tier1_sub: "fino a €3.000",
  calc_tier2_label: "103% 🔥",
  calc_tier2_sub: "da €3.000",
  calc_tier3_label: "157%",
  calc_tier3_sub: "da €5.000",
  calc_tier4_label: "198%",
  calc_tier4_sub: "€10.000",
  calc_return_label: "Rendimento del piano",
  calc_per_year: "al mese",
  calc_monthly_label: "Pensione mensile",
  calc_monthly_sub: "al mese",
  calc_dividend_label: "Reddito annuo da dividendi",
  calc_dividend_sub: "all'anno",
  calc_tip: "Da <1>€3.000</1> il tuo rendimento è <2>103% al mese</2>. A €10.000 — massimo <3>198%</3>.",
  calc_cta: "Firma contratto di investimento",

  // Benefits
  benefits_badge: "Perché sceglierci",
  benefits_title: "Vantaggi di Government Pension Fund Global",
  benefits_desc: "Da oltre 35 anni forniamo reddito pensionistico e da dividendi stabile a migliaia di investitori in tutto il mondo",
  benefits_adv1_title: "Garanzia statale",
  benefits_adv1_desc: "I tuoi investimenti sono protetti dallo stato. Il fondo opera sotto la supervisione del Ministero delle Finanze norvegese dal 1990.",
  benefits_adv2_title: "Crescita stabile",
  benefits_adv2_desc: "Il rendimento annuo medio del fondo negli ultimi 25 anni supera il 6%. Il tuo capitale lavora per te.",
  benefits_adv3_title: "Reddito da dividendi",
  benefits_adv3_desc: "Ricevi pagamenti mensili di dividendi direttamente sul tuo conto. Reportistica trasparente e controllo completo.",
  benefits_adv4_title: "Diversificazione globale",
  benefits_adv4_desc: "Il portafoglio include azioni di oltre 9.000 aziende in 70 paesi. Massima protezione dal rischio.",
  benefits_adv5_title: "Approccio personale",
  benefits_adv5_desc: "Ogni cliente riceve un manager personale e un piano di investimento individuale.",
  benefits_adv6_title: "Condizioni flessibili",
  benefits_adv6_desc: "Scegli una durata del contratto da 5 a 30 anni. Uscita anticipata senza penali.",
  benefits_passive_badge: "Reddito passivo",
  benefits_passive_title1: "Ricevi dividendi",
  benefits_passive_title2: "stabili ogni mese",
  benefits_passive_desc1: "Il reddito da dividendi è il tuo guadagno passivo dagli investimenti nelle più grandi aziende del mondo. Il fondo distribuisce i profitti tra gli investitori ogni mese, fornendo un flusso di cassa stabile.",
  benefits_passive_desc2: "Puoi reinvestire i dividendi per una crescita accelerata del capitale o riceverli sul tuo conto — la scelta è tua.",
  benefits_li1: "Pagamenti ogni mese senza ritardi",
  benefits_li2: "Reinvestimento dei profitti per la crescita",
  benefits_li3: "Reportistica online trasparente",
  benefits_li4: "Ottimizzazione fiscale per gli investitori",
  benefits_stat1: "Pagamento mensile massimo",
  benefits_stat2: "Rendimento massimo",
  benefits_stat3: "Pagamenti all'anno",
  benefits_stat4: "Garanzia statale",
  benefits_reviews_title: "Le storie dei nostri clienti",
  benefits_reviews_sub: "Recensioni reali degli investitori di Government Pension Fund Global",
  benefits_t1_text: "\"Ho investito €10.000 tre anni fa e ora ricevo stabili €4.200 ogni mese. Ha cambiato la mia vita!\"",
  benefits_t1_name: "Anna Müller",
  benefits_t1_meta: "67 · Berlino · Premium",
  benefits_t2_text: "\"Government Pension Fund Global significa affidabilità e stabilità. Il mio reddito da dividendi cresce ogni anno.\"",
  benefits_t2_name: "Klaus Berg",
  benefits_t2_meta: "71 · Oslo · Ottimale",
  benefits_t3_text: "\"Ho iniziato con il piano starter, sono passato al premium dopo un anno. Ora viaggio per il mondo con i miei pagamenti pensionistici.\"",
  benefits_t3_name: "Maria Hansen",
  benefits_t3_meta: "64 · Copenaghen · Premium",

  // Contact
  contact_badge: "Contattaci",
  contact_title1: "Inizia a ricevere",
  contact_title2: "reddito pensionistico oggi",
  contact_desc: "Lascia una richiesta e il nostro manager personale ti contatterà entro 24 ore. Ti aiuteremo a scegliere il contratto di investimento ottimale e risponderemo a tutte le domande.",
  contact_phone_label: "Telefono",
  contact_email_label: "Email",
  contact_address_label: "Indirizzo",
  contact_hours_label: "Orari di lavoro",
  contact_hours_val: "Lun–Ven: 09:00–18:00 (CET)",
  contact_form_title: "Lascia una richiesta",
  contact_fname: "Nome",
  contact_fname_ph: "Il tuo nome",
  contact_lname: "Cognome",
  contact_lname_ph: "Il tuo cognome",
  contact_email: "Email",
  contact_phone: "Telefono",
  contact_plan: "Piano di interesse",
  contact_plan_ph: "Seleziona un piano",
  contact_plan1: "Starter — €3.000 (3–5%)",
  contact_plan2: "Ottimale — €5.000 (103%)",
  contact_plan3: "Premium — €10.000 (157–198%)",
  contact_msg: "Messaggio",
  contact_msg_ph: "Le tue domande o desideri...",
  contact_submit: "Invia richiesta",
  contact_submitting: "Invio in corso...",
  contact_success_title: "Richiesta inviata!",
  contact_success_desc: "Il nostro manager ti contatterà entro 24 ore.",
  contact_privacy: "Cliccando il pulsante, accetti la politica sulla privacy",

  // Footer
  footer_cta_title: "Pronto a iniziare a investire?",
  footer_cta_desc: "Apri un contratto di investimento oggi e inizia a ricevere reddito pensionistico",
  footer_cta_btn: "Apri conto",
  footer_about_desc: "Il più grande fondo pensione sovrano del mondo. Investimenti affidabili con garanzia statale.",
  footer_col1: "Sul Fondo",
  footer_col1_l1: "Storia del fondo",
  footer_col1_l2: "Team di gestione",
  footer_col1_l3: "Rapporti annuali",
  footer_col1_l4: "Centro stampa",
  footer_col2: "Investimenti",
  footer_col2_l1: "Piani pensionistici",
  footer_col2_l2: "Calcolatore di rendimento",
  footer_col2_l3: "Reddito da dividendi",
  footer_col2_l4: "Portafoglio del fondo",
  footer_col3: "Supporto",
  footer_col3_l1: "FAQ",
  footer_col3_l2: "Account personale",
  footer_col3_l3: "Contattaci",
  footer_col3_l4: "Documenti",
  footer_col4: "Legale",
  footer_col4_l1: "Politica sulla privacy",
  footer_col4_l2: "Termini di utilizzo",
  footer_col4_l3: "Licenze",
  footer_col4_l4: "Divulgazione",
  footer_copy: "© 2026 Government Pension Fund Global. Tutti i diritti riservati.",
  footer_disclaimer: "Gli investimenti comportano rischi. Le performance passate non garantiscono rendimenti futuri. Il fondo è supervisionato dal Ministero delle Finanze norvegese.",

  // Live notification
  notif_received: "ha ricevuto",
  notif_plan: "Premium",

  // Plans tiers in calculator
  calc_plan_starter: "Starter",
  calc_plan_optimal: "Ottimale",
  calc_plan_advanced: "Avanzato",
  calc_plan_premium: "Premium",
};

export default translations;
